import React from "react";
// Components
import SummaryHeaderComponent from "./Summary/SummaryHeaderComponent";
import SummaryCardComponent from "./Summary/SummaryCardComponent";
import CartHeaderComponent from "./Detail/CartHeaderComponent";
import CartDetailComponent from "./Detail/CartDetailComponent";
import Loading from "../../common/Loading";

// Context
import { useCart } from "../../../context/CartContext";

// Styles
import "./CartContainer.scss";

const CartContainer = () => {
  const { isLoading } = useCart();

  if (isLoading()) return <Loading isWithShadow />;

  return (
    <section className="cart-container">
      <div className="cart-container__summary">
        <SummaryHeaderComponent />
        <SummaryCardComponent />
      </div>
      <div className="cart-container__detailed">
        <CartHeaderComponent />
        <CartDetailComponent />
      </div>
    </section>
  );
};

export default CartContainer;
